import { useFetchPageV2 } from "~/core/composables/useFetchPageV2";
import { SearchMode, useSearch } from "~/core/composables/useSearch";
import { useSort } from "~/core/composables/useSort";
import type { UseFetchParameters } from "~/core/models/UseFetchParameters.interface";
import ApplicationMgtService from "~/modules/applicationManagement/services/applicationMgt.service";
import { Filters, type FiltersSelection, FiltersType } from "~/types";

export function useFetchAppInterface({ organizationCode }: UseFetchParameters) {
  const service = ApplicationMgtService.getAppInterfaces.bind(
    ApplicationMgtService,
  );

  // To be completed with other filters when they are defined
  const appliedFilters: FiltersSelection = new Map([
    [Filters.NAME, { key: "name", operator: "=like=", value: "" }],
  ]);

  const { searchParams, filters, setFilter, search, onSearch } = useSearch(
    FiltersType.RSQL,
    appliedFilters,
    SearchMode.URL_SEARCH,
  );
  const { sort, onSortChange } = useSort();
  const { isLoading, results, error, fetchData } = useFetchPageV2({
    organizationCode,
    service,
    searchParams,
    sort,
    useQueryParametersForPagination: true,
  });

  return {
    isLoading,
    results,
    error,
    filters,
    fetchData,
    setFilter,
    onSortChange,
    search,
    onSearch,
  };
}
